import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'

export default function MenuLateral({ familias, addFilter }) {
  const [open, setOpen] = React.useState([])

  const loading = useSelector(state => state.listadoArticulos)

  const handleClick = codigoFamilia => {
    if (open.includes(codigoFamilia)) {
      setOpen(open.filter(item => item !== codigoFamilia))
    } else {
      setOpen([...open, codigoFamilia])
      setOpen([...open, codigoFamilia])
    }
  }

  const isMenuDisabled = () => {
    return Object.keys(loading).some(menu => menu?.isLoading === true)
  }

  // Verificar si una familia tiene hijos
  const tieneHijos = codigoFamilia => {
    return familias.some(f => f.codigo_padre === codigoFamilia)
  }

  const renderizarHijos = ({ codigo_padre, style }) => {
    return (
      <Collapse
        in={open.includes(codigo_padre)}
        timeout='auto'
        unmountOnExit>
        {familias.length > 0 &&
          familias.map((_, familia) => {
            if (familias[familia].codigo_padre === codigo_padre) {
              const tieneSubniveles = tieneHijos(familias[familia].codigo_familia)
              return (
                <List
                  key={familias[familia].codigo_familia}
                  component='div'
                  disablePadding>
                  <ListItemButton
                    sx={{ pl: 2 * familias[familia].nivel }}
                    disabled={isMenuDisabled()}
                    onClick={e => {
                      handleClick(familias[familia].codigo_familia)
                      addFilter(familias[familia])
                      if (familias[familia].ultimo_nivel === 'S') {
                        setOpen(prev => prev.filter(item => item !== 'Expanded'))
                      }
                    }}
                    style={{ ...style }}>
                    {tieneSubniveles && (
                      <ListItemIcon>
                        {open.includes(familias[familia].codigo_familia) ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </ListItemIcon>
                    )}
                    <ListItemText secondary={familias[familia].descripcion} />
                  </ListItemButton>
                  {renderizarHijos({
                    codigo_padre: familias[familia].codigo_familia,
                    style: style,
                  })}
                </List>
              )
            }
          })}
      </Collapse>
    )
  }

  const renderMenuResponsive = () => {
    return (
      <div className='menu-lateral-mui'>
        <ListItemButton
          style={{
            width: '100%',
            backgroundColor: '#eeeeee',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
          onClick={() => {
            if (open.includes('Expanded')) {
              setOpen(open.filter(item => item !== 'Expanded'))
            } else {
              setOpen([...open, 'Expanded'])
            }
          }}>
          <ListItemIcon>
            {open.includes('Expanded') ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </ListItemIcon>
          <ListItemText
            key={'-1'}
            primary={'Menu familias'}
            className='texto-primer-nivel-responsive'
          />
        </ListItemButton>

        <Collapse
          onExited={() => {
            document.getElementsByClassName('menu-lateral-mui')[0].scrollIntoView({
              behavior: 'smooth',
            })
          }}
          in={open.includes('Expanded')}>
          {familias.map((_, familia) => {
            const style = {
              '--color-familia': familias[familia]?.reservado_alfa_1 || '#f4f4f4',
              '--border-size': familias[familia]?.reservado_alfa_1 ? '0.5em' : '0em',
            }
            return (
              <>
                {familias[familia].codigo_padre === null ||
                familias[familia].codigo_padre === undefined ? (
                  <Fragment key={familias[familia].codigo_familia}>
                    <ListItemButton
                      style={{ ...style }}
                      onClick={() => {
                        handleClick(familias[familia].codigo_familia)
                        addFilter(familias[familia])
                        if (familias[familia].ultimo_nivel === 'S') {
                          setOpen(prev => prev.filter(item => item !== 'Expanded'))
                        }
                      }}>
                      <ListItemIcon>
                        {open.includes(familias[familia].codigo_familia) ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </ListItemIcon>
                      <ListItemText primary={familias[familia].descripcion?.toLowerCase()} />
                    </ListItemButton>
                    {renderizarHijos({
                      codigo_padre: familias[familia].codigo_familia,
                      style: style,
                    })}
                  </Fragment>
                ) : null}
              </>
            )
          })}
        </Collapse>
      </div>
    )
  }

  const renderMenu = () => {
    return (
      <div className='menu-lateral-mui'>
        {familias.map((_, familia) => {
          const style = {
            '--color-familia': familias[familia]?.reservado_alfa_1 || '#f4f4f4',
            '--border-size': familias[familia]?.reservado_alfa_1 ? '0.5em' : '0em',
          }
          return (
            <>
              {familias[familia].codigo_padre === null ||
              familias[familia].codigo_padre === undefined ? (
                <Fragment key={familias[familia].codigo_familia}>
                  <ListItemButton
                    style={{ ...style }}
                    onClick={() => {
                      handleClick(familias[familia].codigo_familia)
                      addFilter(familias[familia])
                      if (familias[familia].ultimo_nivel === 'S') {
                        setOpen(prev => prev.filter(item => item !== 'Expanded'))
                      }
                    }}>
                    <ListItemIcon>
                      {open.includes(familias[familia].codigo_familia) ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </ListItemIcon>
                    <ListItemText primary={familias[familia].descripcion?.toLowerCase()} />
                  </ListItemButton>
                  {renderizarHijos({
                    codigo_padre: familias[familia].codigo_familia,
                    style: style,
                  })}
                </Fragment>
              ) : null}
            </>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className='menu-lateral-collapsable'>{renderMenuResponsive()}</div>
      <div className='menu-lateral-desktop'>{renderMenu()}</div>
    </>
  )
}
